export const PARA_TI_TRACKS = [
  { title: "Reloj", src: "/music/para-ti-01-reloj.mp3", album: "Para ti, un homenaje" },
  { title: "Nosotros", src: "/music/para-ti-02-nosotros.mp3", album: "Para ti, un homenaje" },
  { title: "Mar y cielo", src: "/music/para-ti-03-mar-y-cielo.mp3", album: "Para ti, un homenaje" },
  { title: "Para Vigo me voy", src: "/music/para-ti-04-para-vigo-me-voy.mp3", album: "Para ti, un homenaje" },
  { title: "Caminemos", src: "/music/para-ti-05-caminemos.mp3", album: "Para ti, un homenaje" },
  { title: "Vacilón", src: "/music/para-ti-06-vacilon.mp3", album: "Para ti, un homenaje" },
  { title: "Envidia", src: "/music/para-ti-07-envidia.mp3", album: "Para ti, un homenaje" },
  { title: "La vida sigue igual", src: "/music/para-ti-08-la-vida-sigue-igual.mp3", album: "Para ti, un homenaje" },
  { title: "Algo contigo", src: "/music/para-ti-09-algo-contigo.mp3", album: "Para ti, un homenaje" },
];

export const ESENCIA_TRACKS = [
  { title: "LLévatela", src: "/music/esencia-01-llevatela.mp3", album: "Esencia de Bolero" },
  { title: "Orfeo negro", src: "/music/esencia-02-orfeo-negro.mp3", album: "Esencia de Bolero" },
  { title: "La negra Tomasa", src: "/music/esencia-03-la-negra-tomasa.mp3", album: "Esencia de Bolero" },
  { title: "Amor, no me quieras tanto", src: "/music/esencia-04-amor-no-me-quieras-tanto.mp3", album: "Esencia de Bolero" },
  { title: "Vivencias", src: "/music/esencia-05-vivencias.mp3", album: "Esencia de Bolero" },
  { title: "Licencia", src: "/music/esencia-06-licencia.mp3", album: "Esencia de Bolero" },
  { title: "Sabor a mí", src: "/music/esencia-07-sabor-a-mi.mp3", album: "Esencia de Bolero" },
  { title: "Flor de un día", src: "/music/esencia-08-flor-de-un-dia.mp3", album: "Esencia de Bolero" },
  { title: "Sombras", src: "/music/esencia-09-sombras.mp3", album: "Esencia de Bolero" },
  { title: "Dos gardenias", src: "/music/esencia-10-dos-gardenias.mp3", album: "Esencia de Bolero" },
  { title: "Échame a mí la culpa", src: "/music/esencia-12-echame-a-mi-la-culpa.mp3", album: "Esencia de Bolero" },
  { title: "Me voy pa'l pueblo", src: "/music/esencia-13-me-voypal-pueblo.mp3", album: "Esencia de Bolero" },
];

export const ALL_TRACKS = [...PARA_TI_TRACKS, ...ESENCIA_TRACKS];
